<template>
  <div>
    <v-menu open-on-click bottom offset-y>
      <img
        slot="activator"
        @click="dateModal = true"
        class="action-icon-lg header-profile"
        :src="mainIcon"
        :class="{ 'border-radius': isBorderRadius }"
        alt="Filter"
      />
      <!-- <img 
        slot="activator"
          @click="dateModal = true"
          class="action-icon-lg"
          src="../assets/icons/filter.png" 
      alt="Filter"/>-->
      <v-list>
        <v-list-tile v-for="(item, index) in items" :key="index" @click="itemSelected(item.value)">
          <v-list-tile-title class="list-tile">
            <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
            <span>{{ item.text }}</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["items", "main-icon"],
  props: {
    items: {
      default: null
    },
    mainIcon: {
      default: ""
    },
    isBorderRadius: {
      default: false
    }
  },
  methods: {
    itemSelected(value) {
      this.$emit("itemSelected", value);
    }
  }
};
</script>

<style scoped>
.icon {
  font-size: 42px;
}
.border-radius{
    border-radius: 50%;
}
.header-profile {
  display: inline-block;
  width: 35px;
  height: 35px;
  object-fit: cover;
}
.list-tile {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
